import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Close } from '@mui/icons-material';
import { grey } from '@mui/material/colors';

import { genConversationInfo, handleLink } from '../constant';
import HeaderIcons from './HeaderIcons';
import remunerationText from
  '../ContactContainer/ContactList/ContactItem/ItemDetails/RemunerationText';

const ConversationHeader = ({
  selected = {}, setSelected, typeData
}) => {
  const data = selected?.dataObject;
  const name = data.companyName || '';
  const info = selected.newContact ? {} :
    (data && genConversationInfo(selected, typeData)) || {};
  const isArtisan = selected.type === 'artisan';
  const remuneration = data.remuneration ?? null
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      sx={{ padding: 1, backgroundColor: 'common.white' }}
      alignItems="center"
    >
      <Box display="flex" alignItems="center"
        style={{ width: 'calc(100% - 160px)' }}>
        <IconButton onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setSelected({});
        }}>
          <Close />
        </IconButton>
        <Box sx={{ width: '100%', overflow: 'hidden' }}>
          <Box display="flex">
            <Typography
              fontWeight="bold"
              fontSize={14}
              children={name.split(' ').map(e => e.capitalize()).join(' ')}
              sx={{ pr: 1, color: grey[800], overflow: 'hidden',
                whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
            />
            {info.statusChip || ''}
            {info.subStatusChip || ''}
          </Box>
          {info && (
            <>
              <Typography
                fontWeight="bold"
                fontSize={13}
                sx={{ color: grey[800], overflow: 'hidden',
                  whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                onClick={() =>
                  selected.type !== 'artisan' &&
                    handleLink(`/${selected.type}/${selected._id}`)
                }
                children={info.text}
              />
              {info.catButtons || ''}
              {info.finalPrice || ''}
            </>
          )}
          {remuneration && <Typography
            component="span"
            fontWeight="bold"
            fontSize={13}
            children={remunerationText(remuneration)}
          />}
        </Box>
      </Box>
      <HeaderIcons
        selected={selected}
        isArtisan={isArtisan}
      />
    </Box>
  );
};

export default ConversationHeader;
